import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { methodIcon, modifierTag } from './methodVisuals';
import styles from './PaymentMethodForm.module.css';

/** Conteúdo do popup de criar/editar: nome e modificador de preço, com a prévia do selo. */
function PaymentMethodForm({ formData, onChange, errors = {} }) {
  const Icon = methodIcon(formData.label);
  const tag = modifierTag(formData.priceModifier);

  return (
    <div className={styles.content}>
      <div className={styles.preview}>
        <span className={styles.previewIcon}><Icon /></span>
        <span className={styles.previewName}>{formData.label || 'Novo método'}</span>
        <span className={`${styles.tag} ${styles[tag.tone]}`}>{tag.text}</span>
      </div>

      <div className={styles.field}>
        <span className={styles.label}>Nome do método</span>
        <TextField
          name="label"
          value={formData.label}
          onChange={onChange}
          fullWidth
          required
          size="small"
          placeholder="Ex.: Pix, Cartão de crédito, Dinheiro"
          error={!!errors.label}
          helperText={errors.label || ''}
          inputProps={{ 'aria-label': 'Nome do método' }}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <span className={styles.label}>Modificador de preço</span>
        <TextField
          name="priceModifier"
          value={formData.priceModifier}
          onChange={onChange}
          fullWidth
          size="small"
          placeholder="0"
          error={!!errors.priceModifier}
          helperText={errors.priceModifier || ''}
          className={styles.input}
          inputProps={{ inputMode: 'decimal', 'aria-label': 'Modificador de preço em porcentagem' }}
          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
        />
        <span className={styles.help}>Use valores negativos para desconto e positivos para acréscimo.</span>
      </div>
    </div>
  );
}

export default PaymentMethodForm;
